import React from 'react'
import { HubCompanyCityHallMembersManagement } from 'domain/feature/hub/company/city-hall-members/index'

export const HubCompanyCityHallMembersPage = (): JSX.Element => {
  return (
    <HubCompanyCityHallMembersManagement />
  )
}